import React, { useContext } from 'react'
import { Container, Title } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { useISAContext } from '../../../components/template/ISA/context'
import { TemplateFormIsa } from '../../../components/template-isa'
import { BlueSubTitle } from '../../../components/BlueText'
import { FormFomik } from './form'

export const DecisionMoney = () => {
  const { creditPath, isMobile } = useContext(TemplateContext)
  const { goToNextScreen } = useISAContext()
  return (
    <TemplateFormIsa>
      <Container>
        <Title text="Se você receber R$100 para dividir entre você e uma pessoa desconhecida, como você dividiria os valores?" />
        <BlueSubTitle>Note que se a pessoa não gostar da divisão, os dois ficam sem nada.</BlueSubTitle>
        <FormFomik data={creditPath && creditPath.ReadShareMoneyWithSomeone} goToNextScreen={goToNextScreen} />
        {isMobile && <div style={{ height: '24px' }} />}
      </Container>
    </TemplateFormIsa>
  )
}
